<template>
  <div class="relative">
    <NuxtLink
        class="relative my-auto"
        to="/cart"
        aria-label="Go to cart"
        external
    >
      <Icon class="text-2xl" icon="cart-shopping" />
      <span
          class="absolute left-4.25 bottom-3.25 px-1.5 py-0.8 w-4 h-4 align-top bg-black text-white rounded-[3px] text-sm max-md:left-2.5 max-md:bottom-1"
          v-if="!!cartCount"
      >
        {{ cartCount }}
      </span>
    </NuxtLink>
    <AddToCartToast class="absolute top-7.5 -right-1.5 z-99999 md:z-50" v-if="showAddToCartToast" />
  </div>
</template>

<script setup lang="ts">

import Icon from '../atom/icon.vue';
import AddToCartToast from '../../AddToCartToast.vue';

interface NavCartButtonProps {
  showAddToCartToast?: boolean;
}

const {
  showAddToCartToast = false
} = defineProps<NavCartButtonProps>();

const cartStore = useCartStore();
const cartCount = computed(() => cartStore.data?.lines.reduce((qty, line) => qty + line.quantity, 0));

</script>